import React from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

import { useModal } from '../Modal/ModalContext';

import { formatCaseStatus, formatNull, formatOverflow } from '../../Utils/GlobalUtils';

import LoadingLines from '../LoadingLines';

import styles from '../../styles/DynamicModal.module.css';
import stylesSearch from '../../styles/Search.module.css';

import IconContainer from '../../Components/IconContainer';
import { ReactComponent as XIcon } from '../../icons/x-close.svg';

export default function SearchCases({ closeModal }) {
    const { openModal } = useModal();
    const navigate = useNavigate();
    const location = useLocation();

    const [cases, setCases] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [warning, setWarning] = React.useState('');

    const inputRef = React.useRef(null);

    React.useEffect(() => {
        inputRef.current?.focus();
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }

    const [searchTerm, setSearchTerm] = React.useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = React.useState('');

    React.useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) handleLogout();
        if (debouncedSearchTerm.trim() == '') {
            setWarning('Введите поисковый запрос');
        } else {
            setLoading(true);

            axios.get(`/api/search-cases?searchterm=${debouncedSearchTerm}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            })
            .then((response) => {
                if (response.data.length === 0) {
                    setCases([]);
                    setWarning('Ничего не найдено');
                } else {
                    setCases(response.data);
                    setWarning('');
                }
            })
            .catch((error) => {
                console.error(error);
                setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
            })
            .finally(() => {
                setLoading(false);
            })
        }
    }, [debouncedSearchTerm]);


    return (
        <div className={styles.liningOver}>
            <motion.div
                className={styles.lining} 
                style={{height: '80vh'}}
                onClick={(e) => e.stopPropagation()}
                initial={{ scale: '97%', opacity: 0 }}
                animate={{ scale: '100%', opacity: 1 }}
                exit={{ scale: '97%', opacity: 0 }}
                transition={{ duration: 0.3 }}
            >
                <div className={styles.header}>
                    <h1>Поиск</h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <div className={stylesSearch.searchInputWrapper}>
                        <input type='text' value={searchTerm} onChange={(e) => {setSearchTerm(e.target.value)}} placeholder='Номер дела, номер вх. корреспонденции или должник...' ref={inputRef} />
                    </div>
                    <div className={stylesSearch.mainWrapper}>
                        {loading ? <LoadingLines />
                        : warning ? <a className={`description ${stylesSearch.centerWarning}`}>{warning}</a>
                        : <>
                            <a className='description'>Первые 20 совпадений</a>
                            <div
                                className='tableRow nonActive' 
                                style={{gridTemplateColumns: '17fr 33fr 33fr 12fr'}} 
                            >
                                <div>
                                    Номер
                                </div>
                                <div>
                                    Должники
                                </div>
                                <div>
                                    Управляющий
                                </div>
                                <div>
                                    Статус
                                </div>
                            </div>
                            {cases.map(caseItem => (
                                <motion.div
                                    className='tableRow'
                                    style={{gridTemplateColumns: '17fr 33fr 33fr 12fr'}}
                                    onClick={() => {navigate(`/case/${caseItem.id}`, { state: { from: location.pathname + location.search + location.hash }})}}
                                    key={caseItem.id}
                                    initial={{ scale: '97%', opacity: 0 }}
                                    animate={{ scale: '100%', opacity: 1 }}
                                    exit={{ scale: '97%', opacity: 0 }}
                                    transition={{ duration: 0.3 }}
                                    layout
                                >
                                    <div>
                                        {formatNull(caseItem.number)}
                                        <a className='description'>{formatNull(caseItem.internal_number)}</a>
                                        {cases.to_case_number && 'Жалоба на: '+caseItem.to_case_number}
                                    </div>
                                    <div>
                                        {caseItem.debtors ?
                                            <p>
                                                {formatOverflow(caseItem.debtors.map((e) => e.name).join(', '))}
                                            </p>
                                            :
                                            formatNull(caseItem.debtors)
                                        }
                                    </div>
                                    <div>
                                        {caseItem.user_id ? (
                                            <>
                                                {caseItem.lastname} {caseItem.firstname} {caseItem.surname} {caseItem.email}
                                            </>
                                            ) : (
                                                'Не выбран СРО'
                                            )
                                        }
                                    </div>
                                    <div>
                                        {formatCaseStatus(caseItem.status)}
                                    </div>
                                </motion.div>
                            ))}
                        </>
                        }
                    </div>
                </div>
            </motion.div>
        </div>
    );
};
